module.exports = __webpack_public_path__ + "media/Ringtone1.6af63b18.mp3";